"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const ToolboxButtonWithDropdown_scss_1 = __importDefault(require("./ToolboxButtonWithDropdown.scss"));
const DropdownMenu_1 = require("../DropdownMenu");
function ToolboxButtonWithDropdown({ items }) {
    const { t } = (0, react_i18next_1.useTranslation)('common');
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isCurrentFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.CURRENT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const selectedTool = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTool);
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(false);
    return (react_1.default.createElement(DropdownMenu_1.DropdownMenu, { items: items, onVisibilityChange: setShowDropdown, isRoot: true },
        react_1.default.createElement("div", { "data-testid": "project-actions-btn" },
            react_1.default.createElement(UI_1.ToolButton, { className: ToolboxButtonWithDropdown_scss_1.default.tooltip, icon: assets_1.svgProjectGeneralIcon, tooltip: showDropdown ? undefined : { content: t('project_actions') }, showDropdownArrow: true, active: showDropdown, "data-role": "horizontal-toolbox-buttons", disabled: isDefaultFastenersWidgetShown ||
                    isCurrentFastenersWidgetShown ||
                    isItemReplacementWidgetShown ||
                    selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS }))));
}
exports.default = ToolboxButtonWithDropdown;
